export default "__VITE_ASSET__Co14S_zj__"